import { ScrollTrigger } from "gsap/all"

const PinGallery = () => {
    const galleryPaackage = document.querySelector('.content-wrapper-sticky')
    const otherAct = document.querySelector('.activities-single-wrapper-inner-featured')
    const headerSize = document.querySelector('header')

    if (galleryPaackage && innerWidth > 900) {
        ScrollTrigger.create({
            pin: galleryPaackage,
            trigger: galleryPaackage,
            endTrigger: otherAct,
            start: `top top+=${headerSize.offsetHeight}px`,
            end: 'bottom bottom'
        })
    }

}


const ButtonCategories = () => {
    const wrapper = document.querySelector('.button-categories')


    if (wrapper) {
        const button = wrapper.querySelector('.button')
        const list = wrapper.querySelector('ul')
        button.addEventListener('click', () => {
            list.classList.toggle('active')
        })
    }
}



const Filter = () => {
    const buttonFilter = document.querySelectorAll('.button-categories ul a')
    const cards = document.querySelectorAll('.all-activities .activity-card-global')

    if (buttonFilter) {
        buttonFilter.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault()
                const id = button.dataset.slug

                document.querySelector('.button-categories .selected-category').innerHTML = button.innerHTML


                if (id) {
                    cards.forEach(item => {
                        item.style.display = 'block'

                        if (!item.classList.contains(id) && id !== 'all') {
                            item.style.display = 'none'
                        }
                    })
                }

            })
        })
    }
}


document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 100);
        });
    });

    // Create pin gallery
    PinGallery()

    ButtonCategories()

    Filter()


})